import React, { useEffect } from 'react'

import { useFormContext } from 'react-hook-form'

import { Card, FileUploadInput } from 'components'

import * as service from 'service'
import helpers from 'helpers'

import useSnackbar from 'hooks/useSnackbar'

const NcAttachmentForm = ({
  isDisabled,
  setLoading,
  monitoringManagementNc,
  refresh,
}) => {
  const { setValue } = useFormContext()
  const snackbar = useSnackbar()

  useEffect(() => {
    setValue('attachments', monitoringManagementNc?.attachments || null)
  }, [monitoringManagementNc]) // eslint-disable-line react-hooks/exhaustive-deps

  const handleRemoveApiFile = async (attachmentId) => {
    setLoading(true)
    try {
      await service.dponet.monitoringManagementNc.destroyAttachment({
        monitoringManagementNcId: monitoringManagementNc?.id,
        attachmentId,
      })

      snackbar.open({
        message: 'Documento removido com sucesso',
        variant: 'success',
      })

      refresh()
    } catch (error) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error?.response?.data?.error) ||
          'Ocorreu uma falha ao remover o documento. Tente novamente.',
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <Card title="Anexe os documentos">
      <FileUploadInput
        controlName="attachments"
        multiple
        controllerBar
        hasDownloadFile
        onRemoveApiFile={handleRemoveApiFile}
        disabled={isDisabled}
      />
    </Card>
  )
}

export default NcAttachmentForm
